<template>
  <div style="width: 100%;">
    <div style="width:100%  display: flex;" class="seven">
      <span>客资来源负责人</span>
      <div id="a1" style="width:100%; height:400px 
      ">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "",
  data () {
    return {

    }
  },
  mounted () {
    this.initBie()
  },
  methods: {
    initBie () {
      var chartDom = document.getElementById('a1');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: 'World Population'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: ['World']
        },
        series: [
          {
            name: '2011',
            type: 'bar',
            data: [100]
          },
          {
            name: '2012',
            type: 'bar',
            data: [200]
          }
        ]
      };

      option && myChart.setOption(option);

    }
  },
  components: {

  },
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/statistics/DatatableId.vue